import styled from 'styled-components';

export default styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-auto-rows: 81px;
  grid-gap: 17px 15px;
  margin: 15px 0;
`;
